import React from 'react';
import pt from 'prop-types';

import Table from 'components/collection/table';
import Link from 'components/link';
import Icon from 'components/icon';

export default class AppStorefronts extends React.PureComponent {
  static propTypes = {
    installedApp: pt.object.isRequired,
    appStorefronts: pt.array.isRequired,
  };

  render() {
    const { installedApp, appStorefronts } = this.props;
    const { app } = installedApp;

    return (
      <Table
        title="Storefronts"
        titleCount={true}
        subtitle="Which storefronts are using this app"
        fields={[
          { label: 'Storefront', func: ({ name }) => name },
          {
            label: 'Version',
            func: ({ theme, theme_version, app_version }) =>
              app.type === 'theme'
                ? theme_version || theme?.version
                : app_version || app?.version,
          },
          {
            label: '',
            align: 'right',
            func: (storefront) => {
              return (
                <b>
                  <Link to={`/storefronts/${storefront.id}`}>
                    View storefront
                  </Link>{' '}
                  <Link to={`/storefronts/${storefront.id}`}>
                    <Icon fa="external-link" />
                  </Link>
                </b>
              );
            },
          },
        ]}
        rows={appStorefronts}
      />
    );
  }
}
